import { Graph2d } from "vis-timeline/esnext";
import { DataSet } from "vis-data/esnext";
import moment from "moment";
import state from "../state";

class StatsTimelineView {
  constructor() {
    this.dom = document.querySelector("#stats-vis");

    this.selectedMetric = "total_cases";

    this.metrics = new DataSet();
    this.groups = new DataSet();

    this.timeline = new Graph2d(this.dom, this.metrics, this.groups, {
      legend: true,
      height: "100%",
      maxHeight: "100%",
      max: moment().add("20", "days"),
      min: "2019-11-01",
      start: "2020-01-01",
      end: "2020-03-03",
      zoomMin: 86400001 * 4.5,
      drawPoints: {
        style: "circle"
      }
    });

    state.channel.subscribe("onGraphLoaded", graph => {
      this.graph = graph;
    });

    state.channel.subscribe("onCountrySelected", country => {
      this.groups.add({
        id: country.id,
        content: country.name,
        className: `group group-${state.countryLabels.assigned(country.id)}`
      });

      this.refreshAll();
    });

    state.channel.subscribe("onCountryRemoved", countryId => {
      this.groups.remove(countryId);
    });

    state.channel.subscribe("onStatsSelected", statsKey => {
      console.log(statsKey)
      this.selectedMetric = statsKey;
      this.refreshAll();
    });
  }

  refreshAll() {
    const timeseries = [];

    this.groups.forEach(group => {
      this.refreshCountry(timeseries, group.id);
    });

    this.timeline.setItems(timeseries);
  }

  refreshCountry(timeseries, countryId) {
    for (const day of this.graph.statsFor(countryId)) {
      timeseries.push({
        x: day.date,
        y: day[this.selectedMetric],
        group: countryId
      });
    }
  }

  syncRangeChange(otherTimeline, callback) {
    this.timeline.on("rangechange", ev => {
      otherTimeline.setWindow(ev.start, ev.end);
      callback(otherTimeline.timeline, this.timeline);
    });
  }

  setWindow(start, end) {
    this.timeline.setWindow(start, end, { animation: false });
  }
}

export default StatsTimelineView;
